import { setContext } from '@apollo/client/link/context';
import { v4 as uuidv4 } from 'uuid';

interface CreateRequestIdLinkProps {
  serverXRequestId?: string;
}

export const createContextLink = ({
  serverXRequestId,
}: CreateRequestIdLinkProps) =>
  setContext((_, { headers: existingHeaders }) => ({
    headers: {
      ...existingHeaders,
      'x-request-id': serverXRequestId ?? uuidv4(),
    },
  }));
